import React, { useState } from 'react';
import { ReactComponent as Close } from '../../svg/close.svg';
import { ReactComponent as EyeOff } from '../../svg/eye-off.svg';
import { ReactComponent as Eye } from '../../svg/eye.svg';
import { ReactComponent as PartyPooper } from '../../svg/filled/party-popper.svg';
import { isEmail } from 'react-multi-email';
import cn from 'classnames';
import { connect } from 'react-redux';
import { authenticate, register } from '../../redux/actions/authActions';
import { authIsLoadingSelector } from '../../redux/selectors/authSelectors';
import { accountFormRegisterState, proceedToCheckoutAfterAuth } from '../../redux/selectors/pagesSelectors';
import { setAccountFormIsVisible, setAccountFormRegisterState } from '../../redux/actions/pagesActions';
import isValidDomain from '../../lib/string/isValidDomain';
import getProductCodeById from '../../resolvers/getProductCodeById';
import { productCurrentProductIdSelector } from '../../redux/selectors/productSelector';
import isRegistrationWebsiteFieldRequired from '../../resolvers/isRegistrationWebsiteFieldRequired';

function RegisterForm({ loginForm, setLoginForm, setModalOpened, authenticate, register, authIsLoading, noCloseBtn, mainProductId, proceedToCheckoutAfterAuth }) {
    const [inputPasswordType, setInputTypePassword] = useState('password');
    const [showEmailError, setShowEmailError] = useState(false);
    const [showWebsiteError, setShowWebsiteError] = useState(false);
    const [showPrivacyPolicyAcceptanceError, setShowPrivacyPolicyAcceptanceError] = useState(false);
    const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(true);
    const toggleEyeInput = () => {
        setInputTypePassword(inputPasswordType === 'password' ? 'text' : 'password');
    };
    const [emptyInput, setEmptyInput] = useState(true);
    const [email, setEmail] = useState('');
    const [website, setWebsite] = useState('');
    const [password, setPassword] = useState('');
    const [emptyPassword, setEmptyPassword] = useState(true);
    const [startTypePassword, setStartTypePassword] = useState(false);
    const [emptyWebsite, setEmptyWebsite] = useState(true);
    const websiteAddressTitle = () => {
        return `Website address${isRegistrationWebsiteFieldRequired(mainProductId) ? '' : ' (optional)'}`;
    }

    const handleAcceptPrivacyPolicy = (e) => {
        setPrivacyPolicyAccepted(e.target.checked);
        setShowPrivacyPolicyAcceptanceError(false);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (emptyInput) {
            setShowEmailError(true);
            return;
        } else if (showEmailError) {
            return;
        }
        if (loginForm) {
            if (!!emptyPassword) {
                setEmptyPassword(true);
                setStartTypePassword(true);
            } else {
                authenticate({
                    email: email,
                    password: password,
                });
            }
        } else {
            if (!privacyPolicyAccepted) {
                setShowPrivacyPolicyAcceptanceError(true);
            } else {

                if (isRegistrationWebsiteFieldRequired(mainProductId) && emptyWebsite) {
                    setShowWebsiteError(true);
                } else {
                    if (isRegistrationWebsiteFieldRequired(mainProductId) && !isValidDomain(website, ['http', 'https'])) {
                        setShowWebsiteError(true);
                    } else {
                        let data = {
                            email: email,
                            lead_source: 'pay_cleantalk',
                            product_name: getProductCodeById(mainProductId)
                        };
                        if (website && !emptyWebsite && !showWebsiteError) {
                            data.website = website;
                        }
                        // Set payment provider gateway ID to use it after successful registration.
                        if (proceedToCheckoutAfterAuth) {
                            data.proceedToCheckoutAfterAuth = proceedToCheckoutAfterAuth;
                        }
                        register(data);
                    }
                }
            }
        }
    };

    const handeEmailInput = (e) => {
        if (e.target.value !== '') setEmptyInput(false);
        else setEmptyInput(true);

        setEmail(e.target.value);
    };

    const handlePasswordInput = (e) => {
        // Mark the input as one which has been typed in (in order to start showing a warning in case of empty input).
        setStartTypePassword(true);
        if (e.target.value !== '') setEmptyPassword(false);
        else setEmptyPassword(true);

        setPassword(e.target.value);
    };

    const handleWebsiteInput = (e) => {
        if (e.target.value !== '') setEmptyWebsite(false);
        else setEmptyWebsite(true);

        setWebsite(e.target.value);
        setShowWebsiteError(false);
    };

    return (
        <div className={'block-hover'}>
        <form className={'form__container width--710 form--modal'} onSubmit={handleSubmit}>
            {loginForm ? (
                <>
                    <p className={'color--black text-1 mb-10'}>Log in</p>
                    <p className={'text flex flex--center flex--justify-center'}>
                        <PartyPooper className={'size-20 mr-7'} />
                        Welcome back, please log in to your account.
                    </p>
                </>
            ) : (
                <>
                    <p className={'color--black text-1 mb-10'}>Create an account</p>
                    <p className={'text'}>
                        Sing up for an account to finish the purchase. In a minute, you will have
                        instructions to set up and test the service.
                    </p>
                </>
            )}

            <div className={'form__row mt-60 mb-42'}>
                <input
                    className={cn('form__input', {
                        'is-invalid': showEmailError,
                        'is-typed': !emptyInput,
                    })}
                    id="ct-email"
                    type="email"
                    placeholder="Email address"
                    onInput={handeEmailInput}
                    onBlur={(e) => {
                        if (e.target.value && !isEmail(e.target.value)) setShowEmailError(true);
                    }}
                    onFocus={() => setShowEmailError(false)}
                />
                <label
                    className={cn('form__label form__label--floating', {
                        'form__label--error': showEmailError,
                    })}
                    htmlFor={'ct-email'}
                >
                    Email address
                </label>
                <span className={cn('form__error', { hidden: !showEmailError })}>
                    Invalid email address
                </span>
            </div>

            {loginForm ? (
                <div className={'form__row mb-16'}>
                    <input
                        className={cn('form__input form__input--with-icon', {
                            'is-typed': !emptyPassword,
                        })}
                        id="ct-password"
                        type={inputPasswordType}
                        placeholder="Password"
                        onInput={handlePasswordInput}
                    />
                    <label className={'form__label form__label--floating'} htmlFor={'ct-password'}>
                        Password
                    </label>
                    <span className={cn('form__error', { hidden: !(emptyPassword && startTypePassword) })}>
                        Field is required
                    </span>
                    <EyeOff
                        id="EyeOff"
                        className={
                            inputPasswordType === 'password'
                                ? 'icon form__input-icon'
                                : 'icon form__input-icon hidden'
                        }
                        onClick={toggleEyeInput}
                    />
                    <Eye
                        id="EyeOn"
                        className={
                            inputPasswordType === 'password'
                                ? 'icon form__input-icon hidden'
                                : 'icon form__input-icon'
                        }
                        onClick={toggleEyeInput}
                    />
                </div>
            ) : (
                <div className={'form__row mb-16'}>
                    <input
                        className={cn('form__input', {
                            'is-typed': !emptyWebsite,
                            'is-invalid': showWebsiteError,
                        })}
                        id="ct-website"
                        type="text"
                        placeholder={websiteAddressTitle()}
                        onInput={handleWebsiteInput}
                    />
                    <label className={'form__label form__label--floating'} htmlFor={'ct-website'}>
                        {websiteAddressTitle()}
                    </label>
                    <span className={cn('form__error', { hidden: !showWebsiteError })}>
                        Invalid website address
                    </span>
                </div>
            )}
            {loginForm ? (
                <p className={'text--left'}>
                    <a
                        href="https://cleantalk.org/my/reset_password"
                        target={'_blank'}
                        className={'color--blue-2 link--no-underline underline--hover'}
                    >
                        Forgot password?
                    </a>
                </p>
            ) : (
                <div className="form__checkbox flex--align-start">
                    <input type="checkbox" id="priv-policy" className="form__input--checkbox"
                           checked={privacyPolicyAccepted} onChange={handleAcceptPrivacyPolicy} />
                    <label htmlFor="priv-policy" className="form__checkbox-label">
                        <i className={'color--gray'}>
                            I agree with the&nbsp;
                            <a
                                href="https://cleantalk.org/publicoffer#privacy"
                                target={'_blank'}
                                className={'color--gray underline'}
                            >
                                Privacy policy
                            </a>
                            <span className={cn('form__error', { hidden: !showPrivacyPolicyAcceptanceError })}>
                            Privacy policy is not accepted
                        </span>
                        </i>
                    </label>
                </div>
            )}

            <button
                type={'submit'}
                //disabled={!submitEnabled}
                className={cn(
                    'button button--bg-blue button--height-50 mt-42 width--400 b-radius mb-16 relative',
                    {
                        //disabled: !submitEnabled,
                    }
                )}
            >
                {authIsLoading ? (
                    <span className="spinner spinner--in-button" />
                ) : (
                    <span className={'text-3 l-spacing color--white'}>
                        {loginForm ? <>Log in</> : <>Create account</>}
                    </span>
                )}
            </button>

            {loginForm ? (
                <p>
                    You don’t have an account?&nbsp;
                    <button
                        type={'button'}
                        className={'button--reset'}
                        onClick={() => setLoginForm(false)}
                    >
                        <span className={'color--blue-2 underline'}>Create account</span>
                    </button>
                </p>
            ) : (
                <p>
                    Already have an account?&nbsp;
                    <button
                        type={'button'}
                        className={'button--reset'}
                        onClick={() => setLoginForm(true)}
                    >
                        <span className={'color--blue-2 underline'}>Log in</span>
                    </button>
                </p>
            )}

            {!noCloseBtn && (
                <button
                    type={'button'}
                    className={'button--reset modal__close size-24'}
                    onClick={() => setModalOpened(false)}
                >
                    <span className={'visually-hidden'}>Close Modal</span>
                    <Close className={'icon size-12'} />
                </button>
            )}
        </form>
        </div>
    );
}

const mapStateToProps = (state) => ({
    authIsLoading: authIsLoadingSelector(state),
    loginForm: accountFormRegisterState(state),
    mainProductId: productCurrentProductIdSelector(state),
    proceedToCheckoutAfterAuth: proceedToCheckoutAfterAuth(state),
});

const mapDispatchToProps = (dispatch) => ({
    authenticate: (data) => dispatch(authenticate(data)),
    register: (data) => dispatch(register(data)),
    setModalOpened: (flag) => dispatch(setAccountFormIsVisible(flag)),
    setLoginForm: (flag) => dispatch(setAccountFormRegisterState(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterForm);
